export default __webpack_public_path__ + "img/dnTxaMLo.3437bce9.svg";